<template>
  <div class="item-teaching-course">
    <BaseIcon name="school" :color="color" size="xs" />
    <div
      class="item-teaching-course__item"
    >
      <span>{{ coursesText }}</span>
      <span v-if="diffList" class="more">... +{{ diffList }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeacherListItemsTeachingCourse',
  inject: ['teacher'],
  computed: {
    ...mapGetters('local', ['getTutorListDesignColor']),
    color () {
      return this.teacher?.designColor || this.getTutorListDesignColor
    },
    courses () {
      return this.teacher.teachingCourses
    },
    coursesText () {
      const c = this.courses.slice(0, 2)
      let text = c[0].name
      if (c[1]) {
        text += ', '
        text += c[1].name
      }
      return text
    },
    diffList () {
      return Math.abs(this.courses.length - 2)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.item-teaching-course {
  @apply flex items-center space-x-2 w-full overflow-hidden lg:max-w-[400px];
  &__item {
    @apply w-full text-overflow-dots text-left;
    > span {
      @apply text__caption-xs--bold lg:text__body-2-xs--semibold text-body-1;
    }
  }
  .more {
    @apply lg:text__body-2-md--semibold text__caption-xs--semibold text-body-2;
  }
}
</style>
